import React, { useRef, useEffect, useState, useReducer } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, FormElement } from "@progress/kendo-react-form";
import "./dialogDeleteMultiSignature.css";
import P5ContainerSignatures from "../dialogDeleteMultiSignature/P5ContainerSignatures";
import { useMediaQuery } from "@material-ui/core";
import { PDFDocument } from "pdf-lib";
import { pdfjs } from "react-pdf";

const gotToEnd = () => {
  let out = document.getElementsByClassName("k-dialog-content");
  out[0].scrollTop = out[0].scrollHeight * 0.7;
};

const saveImage = (nameSigner) => {
  let destinationCanvas = document.createElement("canvas");
  destinationCanvas.height = 300;
  destinationCanvas.width = 600;
  const x = destinationCanvas.width;
  let destinationContext = destinationCanvas.getContext("2d");
  destinationContext.font = "bold 25px Arial";
  destinationContext.textAlign = "center";
  destinationContext.fillText(nameSigner, x / 2, 255);

  destinationContext.rect(
    0,
    0,
    destinationCanvas.width,
    destinationCanvas.height
  );

  destinationContext.strokeRect(
    0,
    0,
    destinationCanvas.width,
    destinationCanvas.height
  );

  destinationContext.globalCompositeOperation = "destination-over";

  let image = destinationCanvas.toDataURL("image/png");
  return {
    newImg: image,
    imageWidth: destinationCanvas.width,
    imageHeight: destinationCanvas.height,
  };
};

const CustomTitleBar = ({ signatureType }) => {
  const { t } = useTranslation();
  return (
    <div className="custom-title">
      <span>
        {t("dialogAcceptSignature.titleAcceptSignRequest", {
          signatureType: signatureType,
        })}
      </span>
    </div>
  );
};

const initialValuesState = {
  activeOnSubit: false,
  signatureData: {},
};

function valuesReducerActions(state, action) {
  switch (action.type) {
    case "setActiveOnSubit":
      return { ...state, activeOnSubit: action.data };
    default:
      throw new Error();
  }
}

const DialogDeleteMultiSignature = (props) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [pagesSize, setPagesSize] = useState([]);
  const [numPages, setNumPages] = useState(null);
  const [tempImgPages, setTempImgPages] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [pager, setPager] = useState(1);
  const [currentSystem, setCurrentSystem] = useState("");
  const { t } = useTranslation();
  const [imgSignature, setImgSignature] = useState(null);
  const [widthImgSignature, setWidthImgSignature] = useState(400);
  const [heightImgSignature, setHeightImgSignature] = useState(300);
  const [pagesImgs, setPagesImgs] = useState([]);
  const [visibleAccept, setVisibleAccept] = useState(false);
  const [divGreyTextSize, setdivGreyTextSize] = useState(700);
  const greyTextRef = useRef(null);

  const [sign, setSign] = useState(0);
  const [numSign, setNumSign] = useState(0);

  const [values, dispatchValues] = useReducer(
    valuesReducerActions,
    initialValuesState
  );
  const toggleDialogAccept = () => {
    const { newImg } = saveImage(props.dataItem.nameSigner);
    setImgSignature(newImg);
    setVisibleAccept(!visibleAccept);
  };

  let greyText = "dialogAcceptSignature.noticeCreateSignAutografaCustom";
  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  const isTouchScreendevice = () =>
    "ontouchstart" in window || navigator.maxTouchPoints;
  if (isTouchScreendevice()) isMobile = true;
  useEffect(() => {
    setNumPages(props.numPages);
    setPageNumber(props.pageNumber);
    setPager(props.pager);
    setTempImgPages(props.tempImgPages);
  }, [props.numPages, props.pageNumber, props.pager, props.tempImgPages]);
  useEffect(() => {
    if (props.signRequestPDF) getPdgPageSize();
  }, [props.signRequestPDF]);

  const getPdgPageSize = async () => {
    const pdfDoc = await PDFDocument.load(pdfFile);
    const pages = pdfDoc.getPages()
    let sizes = pages.map((i) => i.getSize());
    setPagesSize(sizes);
  };
  let pdfFile =
    "data:application/pdf;filename=file.pdf;base64," + props.signRequestPDF;

  const saveCoordinates = () => {
    props.dataItem.numSign--;

    props.setSigners(
      props.signers.map((item) =>
        props.dataItem.email === item.email
          ? {
            ...item,
            numSign: props.dataItem.numSign,
          }
          : item
      )
    );
  };

  useEffect(() => {
    const divGreyText = greyTextRef.current;
    if (divGreyText) {
      if (divGreyText.clientWidth) {
        setdivGreyTextSize(divGreyText.clientWidth);
      }
    }
  }, [visibleAccept]);

  const changePageSign = (offset) => {
    setSign(offset);
    setPageNumber(props.signatures[offset - 1].page);
  };

  useEffect(() => {
    setNumSign(props?.signatures.length);
    if (props?.signatures.length >= 1) {
      setSign(1);
    }
  }, [props?.signatures]);

  const previousSign = () => {
    if (sign <= 1) return;
    changePageSign(sign - 1);
  };

  const nextSign = () => {
    if (sign >= numSign) return;
    changePageSign(sign + 1);
  };

  useEffect(() => {
    let tempArr = [...Array(numPages)];
    for (const key in tempImgPages) {
      tempArr[Number(key)] = tempImgPages[key];
    }
    setPagesImgs(tempArr);
  }, [tempImgPages]);

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  const isPhone = useMediaQuery("(max-width:500px)");
  const { innerWidth: fullWidth } = window;
  if (isMobile)
    greyText = "dialogAcceptSignature.noticeCreateSignAutografaMobile";
  return (
    <div>
      <div className="dialogContent">
        {/* <button
            onClick={() => toggleDialogAccept()}
            className="dialog-accept-signature-autograf-button-signs-details"
            style={{ marginTop: "4px", marginBottom: "4px" }}
          >
            {t("documentDisplay.locate")}
          </button> */}
        <div
          style={{ marginTop: "4px", marginBottom: "4px" }}
          onClick={() => {
            // props.toggleDialogDeleteSigner(props.dataItem);
            toggleDialogAccept();
          }}
        >
          <i
            style={{ cursor: "pointer" }}
            className="k-icon k-i-delete k-i-trash"
          ></i>{" "}
        </div>
        {visibleAccept && !props?.showLoadingRequesting && (
          <Dialog
            title={
              <CustomTitleBar
                style={{ maxWidth: `${fullWidth}px !important` }}
                signatureType={"Eliminar firma"}
              />
            }
            className="dialog-signature"
            onClose={toggleDialogAccept}
          >
            <div
              className="calligraphic-grey-text"
              style={{
                maxWidth: `${divGreyTextSize}px`,
                height: "auto",
                backgroundColor: "#DEDEDE",
                position: "fixed",
                zIndex: 100,
              }}
            >
              <div
                style={{ padding: "15px 35px 15px 35px", fontWeight: "500" }}
              >
                <p
                  style={{
                    margin: "0px",
                    fontFamily: "Quicksand",
                    lineheight: "1.4",
                  }}
                >
                  {t(greyText)}
                </p>
                {greyText ===
                  "dialogAcceptSignature.noticeCreateSignAutografa" && (
                    <p
                      style={{
                        margin: "0px",
                        fontFamily: "Quicksand",
                        lineheight: "1.4",
                      }}
                    >
                      {t("dialogAcceptSignature.noticeCreateSignAutografa2")}
                    </p>
                  )}
              </div>
            </div>
            <div
              ref={greyTextRef}
              style={{
                width: "100%",
                height: "auto",
                backgroundColor: "#DEDEDE",
              }}
            >
              <div
                style={{ padding: "15px 35px 15px 35px", fontWeight: "500" }}
              >
                <p
                  style={{
                    margin: "0px",
                    fontFamily: "Quicksand",
                    lineheight: "1.4",
                    paddingBottom: "10px",
                  }}
                >
                  {t(greyText)}
                </p>{" "}
                {greyText ===
                  "dialogAcceptSignature.noticeCreateSignAutografa" && (
                    <p
                      style={{
                        margin: "0px",
                        fontFamily: "Quicksand",
                        lineheight: "1.4",
                      }}
                    >
                      {t("dialogAcceptSignature.noticeCreateSignAutografa2")}
                    </p>
                  )}
              </div>
            </div>
            <div>
              <Form
                style={{ margin: "0px" }}
                onSubmit={() => { }}
                allowSubmit={true}
                className="formCustomSignature"
                valid={true}
                touched={true}
                visited={true}
                render={() => {
                  return (
                    <FormElement
                      style={{
                        maxWidth: "450px !important",
                        width: "100%",
                        margin: "auto",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            width: pagesSize[0].width + 16,
                            height: pagesSize[0].height + 16,
                          }}
                        >
                          <div>
                            <div
                              className={`button-dialog-accept button-dialog-accept-size icons-bars`}
                            >
                              <span
                                class="k-icon k-i-arrow-double-60-left icon-bar dialog-input-arrow-padding"
                                onClick={() => {
                                  setPageNumber(props.signatures[0].page);
                                  setSign(1);
                                }}
                              ></span>
                              <span
                                class="k-icon k-i-arrow-60-left icon-bar dialog-input-arrow-padding"
                                onClick={previousSign}
                              ></span>
                              <div
                                className="pagec"
                                style={{
                                  color: "#427FBA",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                  padding: "0px 5px",
                                }}
                              >
                                Firmas
                                <input
                                  style={{
                                    width: "32px",
                                    marginLeft: "4px",
                                    marginRight: "3px",
                                  }}
                                  type="text"
                                  value={sign}
                                  onChange={({ target }) => {
                                    setSign(Number(target.value));
                                    if (Number(target.value) <= numSign) {
                                      if (Number(target.value) <= 0) {
                                        setNumSign(0);
                                        setSign(0);
                                      }
                                      //Modificar para ver a que pagina tiene que ir
                                      else setPageNumber(Number(target.value));
                                    } else
                                      setTimeout(() => {
                                        setSign(pageNumber);
                                      }, 1000);
                                  }}
                                />
                                {t("documentDisplay.of")}{" "}
                                {props.signatures.length || "--"}
                              </div>
                              <span
                                class="k-icon k-i-arrow-60-right icon-bar dialog-input-arrow-padding"
                                onClick={nextSign}
                              ></span>
                              <span
                                class="k-icon k-i-arrow-double-60-right icon-bar dialog-input-arrow-padding"
                                onClick={() => {
                                  setPageNumber(
                                    props.signatures[numSign - 1].page
                                  );
                                  setSign(numSign);
                                }}
                              ></span>
                            </div>
                          </div>
                          {pagesImgs.map((item, index) => (
                            <React.Fragment key={String(index)}>
                              <div
                                style={
                                  index === pageNumber - 1
                                    ? {}
                                    : { display: "none" }
                                }
                              >
                                <P5ContainerSignatures
                                  tFunction={t}
                                  email={props.dataItem.email}
                                  deleteSign={(e) => {
                                    props.toggleLoadingRequesting(true)
                                    saveCoordinates()
                                    props.deleteSignaturesByIndex(e)
                                    props.setWasChanged(true)
                                    toggleDialogAccept()
                                  }}
                                  base64Img={item}
                                  widthImg={pagesSize[index].width}
                                  heightImg={pagesSize[index].height}
                                  imgSignature={imgSignature}
                                  widthImgSignature={widthImgSignature}
                                  heightImgSignature={heightImgSignature}
                                  currentPage={index + 1}
                                  signatures={props.signatures}
                                  pageNumber={index}
                                  saveCoordinates={(params) =>
                                    saveCoordinates(params)
                                  }
                                  save={async (params) => {
                                    let temp = {
                                      ...params,
                                      page: index + 1,
                                    };
                                    let { signatures } = props;
                                    let fileSignImage = null;
                                    await fetch(imgSignature)
                                      .then((res) => res.blob())
                                      .then((blob) => {
                                        const file = new File(
                                          [blob],
                                          "signature.png"
                                        );
                                        fileSignImage = file;
                                      });
                                    let signs = signatures;
                                    signs.push({
                                      x: temp.x,
                                      y: temp.y,
                                      width: temp.width,
                                      height: temp.height,
                                      page: index + 1,
                                      isMobile: true,
                                      fileSignImage: fileSignImage,
                                      imgSignature: imgSignature,
                                      email: props.dataItem.email,
                                    });
                                    props.setSignatures(signs);
                                    props.setWasChanged(true);
                                    toggleDialogAccept();
                                  }}
                                  activeOnSubit={values.activeOnSubit}
                                  signatureData={values.signatureData}
                                  dispatchValues={dispatchValues}
                                  back={() => {
                                    setVisibleAccept(!visibleAccept);
                                  }}
                                  isMobile={false}
                                  gotToEnd={gotToEnd}
                                  isPhone={isPhone}
                                />
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    </FormElement>
                  );
                }}
              />
            </div>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export { DialogDeleteMultiSignature as default };
